
export function deepClean(obj) {
  if (Array.isArray(obj)) {
    return obj
      .map(deepClean)
      .filter(
        (item) =>
          item !== undefined &&
          item !== null &&
          !(typeof item === "string" && item.trim() === "") &&
          !(Array.isArray(item) && item.length === 0) &&
          !(typeof item === "object" && Object.keys(item).length === 0)
      );
  } else if (typeof obj === "object" && obj !== null) {
    return Object.entries(obj).reduce((acc, [key, value]) => {
      const cleaned = deepClean(value);
      if (
        cleaned !== undefined &&
        cleaned !== null &&
        !(typeof cleaned === "string" && cleaned.trim() === "") &&
        !(Array.isArray(cleaned) && cleaned.length === 0) &&
        !(typeof cleaned === "object" && Object.keys(cleaned).length === 0)
      ) {
        acc[key] = cleaned;
      }
      return acc;
    }, {});
  }
  return obj;
}



export function getURLParams(filters) {
  if (!filters || Object.keys(filters).length === 0) return "";
  const cleaned = deepClean(filters);
  console.log("CLEANED FILTERS:", cleaned);
  if (Object.keys(cleaned).length === 0) return "";
  return `filters=${JSON.stringify(cleaned)}`;
}